/**
 * THE PLAN'S WORDS (EXPERT-NETWORKS.md §1, E1) — one plan tree, named by the network: Milestone → Epic → Task
 * (default) or, for an Expert Network, Team → Responsibility → Rule (or the network's own words). Display only —
 * ids, ledger fields and gates never change. Mirrors ``stepflow_core.plan_vocabulary.normalize``.
 */
import { createContext, useContext } from 'react';

const DEFAULTS = {
  standard: { group: 'Milestone', item: 'Epic', leaf: 'Task' },
  expert: { group: 'Team', item: 'Responsibility', leaf: 'Rule' },
};
const LABEL = /^[A-Za-z][A-Za-z &/-]{0,23}$/;

function plural(w) {
  if (/(s|x|z|ch|sh)$/i.test(w)) return `${w}es`;
  if (/[^aeiou]y$/i.test(w)) return `${w.slice(0, -1)}ies`;
  return `${w}s`;
}

/** Stored / served vocabulary (or nothing) → the words, with plurals + lower-case forms. */
export function planWords(raw) {
  const v = raw && typeof raw === 'object' ? raw : {};
  const kind = v.kind === 'expert' ? 'expert' : 'standard';
  const out = { kind, expert: kind === 'expert' };
  ['group', 'item', 'leaf'].forEach((k) => {
    const s = String(v[k] || '').replace(/\s+/g, ' ').trim();
    out[k] = LABEL.test(s) ? s : DEFAULTS[kind][k];
  });
  out.groups = plural(out.group); out.items = plural(out.item); out.leaves = plural(out.leaf);
  ['group', 'item', 'leaf', 'groups', 'items', 'leaves'].forEach((k) => { out[`${k}Lc`] = out[k].toLowerCase(); });
  return out;
}

export const PlanWordsContext = createContext(planWords(null));
export function usePlanWords() { return useContext(PlanWordsContext); }
